import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  close: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  }
}));

const CloseButton = ({ onClick }) => {
  const classes = useStyles();
  return (
    <IconButton onClick={onClick} className={classes.close}>
      <CloseIcon />
    </IconButton>
  );
}

export default CloseButton;